import { MenuItem } from '@mui/material';
import PropTypes from 'prop-types';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import { Link } from 'react-router-dom';

function NavItem({ item, onNavigate }) {
    // eslint-disable-next-line react/prop-types
    const Icon = item.icon;

    return (
        <MenuItem
            component={Link}
            to={item.url}
            style={{ height: '60px' }}
            onClick={onNavigate}
        >
            <ListItemIcon>
                <Icon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{item.title}</ListItemText>
        </MenuItem>
    );
}

NavItem.propTypes = {
    item: PropTypes.shape({
        title: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
    }).isRequired,
    onNavigate: PropTypes.func,
};

NavItem.defaultProps = {
    onNavigate: () => {},
};

export default NavItem;
